export const userType = {
  admin: {
    login: 'admin',
    password: '123123',
  },
  user: {
    login: 'user',
    password: '123',
  },
}
